import MarketplaceWidgetData from "./MarketplaceWidgetData";

export { MarketplaceWidgetData };
